<template>
  <div>
    <ConfirmDialog group="templating">
      <template #message="slotProps">
        <div class="flex flex-col items-center w-full gap-3 border-b border-gray-400">
          <i :class="slotProps.message.icon" class="text-6xl text-blue-600"></i>
          <p>{{ slotProps.message.message }}</p>
        </div>
      </template>
    </ConfirmDialog>
  </div>
</template>

<script setup>
import { watch } from "vue";
import { translate } from "@/composables/translate";
import { useConfirm } from "primevue/useconfirm";
import ConfirmDialog from 'primevue/confirmdialog';


const emit = defineEmits(['confirmResponse'])
const props = defineProps({ 
  showConfirm: {
    type: Boolean,
    required: false
  },
  title: {
    type: String,
    required: false,
    default: 'confirmation'
  },
  message: {
    type: String,
    required: false,
    default: 'please confirm to proceed moving forward'
  },
  icon: {
    type: String,
    required: false,
    default: 'pi pi-exclamation-circle'
  },
  acceptIcon: {
    type: String,
    required: false,
    default: 'pi pi-check'
  },
  rejectIcon: {
    type: String,
    required: false,
    default: 'pi pi-times'
  },
  rejectClass: {
    type: String,
    required: false,
    default: 'button-sm'
  }, 
  acceptClass: {
    type: String,
    required: false,
    default: 'outlined button-sm'
  }, 
});

const confirm = useConfirm();

const confirmDialog = () => {
  confirm.require({
    group: 'templating',
    header: translate(props.title, "ucfirst"),
    message: translate(props.message, "ucfirst"),
    icon: props.icon,
    acceptIcon: props.acceptIcon,
    rejectIcon: props.rejectIcon,
    rejectClass: props.rejectClass,
    acceptClass: props.acceptClass,
    acceptLabel: translate('yes', "ucfirst"),
    rejectLabel: translate('no', "ucfirst"),
    onHide: () => {
      emit('confirmResponse', false) 
    },
    accept: () => {
      emit('confirmResponse', {accepted: true, close: false}) 
    },
    reject: () => {
      emit('confirmResponse', false)
    }
  });
};

watch(() => props.showConfirm, (newValue) => {
  if (newValue) {
    confirmDialog()
  }
})
</script>